export function PromoCodeService($http, $q, cartService, cartStatusChannel, googleAnalyticsTrackingService,
    addressService, featureFlagService) {
    'ngInject';

    const data = {
        appliedCode: '',
        displayedCode: ''
    };

    const service = {
        data,
        applyPromoCode,
        removePromoCode,
        clearAppliedCode
    };

    _activate();

    return service;


    function _activate() {
        cartService.getCart().then(cart => {
            data.appliedCode = cart.check.appliedPromoCode;
            data.displayedCode = cart.check.appliedPromoCode;
        });
    }

    function _trackApply(succeeded, promoCode) {
        googleAnalyticsTrackingService.trackPromoCode(
            'apply', succeeded, promoCode);
    }

    function _trackRemove(succeeded, promoCode) {
        googleAnalyticsTrackingService.trackPromoCode(
            'remove', succeeded, promoCode);
    }

    function clearAppliedCode() {
        data.appliedCode = '';
    }

    /**
     * @returns {Promise<void>}
     */
    function applyPromoCode() {
        if (data.displayedCode === data.appliedCode) {
            data.displayedCode = '';
            return $q.resolve();
        }
        return _doApply();
    }

    function _getPromoCodeUrl() {
        return `${cartService.getCartUrl()}/promocodes`;
    }

    function _doApply() {
        const promoCode = data.displayedCode;

        return $http({
            url: _getPromoCodeUrl(),
            method: 'PUT',
            dataType: 'JSON',
            headers: {
                'Content-Type': 'application/json'
            },
            data: promoCode,
            skipCallout: true
        }).then(
            response => {
                _trackApply(true, promoCode);

                const cart = response.data;

                data.displayedCode = '';

                cartService.setCart(cart);

                if (cartService.data.cart.check.promoCodeDiscount) {
                    // G2 might not currently return the promo code for an AppliedDiscount so
                    // we'll assume if there's a discount it's because we applied it.
                    data.appliedCode = cartService.data.cart.check.appliedPromoCode || promoCode;
                } else {
                    data.appliedCode = '';
                }

                _updateCart();
            },
            error => {
                _trackApply(false, promoCode);
                cartService.modifyCartErrorHandler({ errResp: error });
                return $q.reject(error);
            }
        );
    }

    /**
     * @returns {Promise<void>}
     */
    function removePromoCode() {
        if (data.appliedCode === '') {
            return $q.resolve();
        }
        return _doRemove();
    }

    function _doRemove() {
        const promoCode = data.appliedCode;

        return $http({
            url: _getPromoCodeUrl(),
            method: 'DELETE',
            dataType: 'JSON',
            skipCallout: true
        }).then(
            response => {
                _trackRemove(true, promoCode);

                const cart = response.data;

                data.appliedCode = '';
                data.displayedCode = '';

                cartService.setCart(cart);

                cartStatusChannel.changedCart();
            },
            error => {
                _trackRemove(false, promoCode);
                cartService.modifyCartErrorHandler({ errResp: error });
                return $q.reject(error);
            }
        );
    }

    function _updateCart() {
        cartService.updateCart({
            tipAmount: null,
            paymentMethod: null,
            skipCallout: true,
            deliveryInfo: addressService.data
        });
    }
}
